var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table-cell-wrapper',{attrs:{"placeholder":_vm.contextualPlaceholder,"highlighted":_vm.record.isHighlighted('type', 'broadcast_type', 'channel', 'band')}},[(_vm.record.isBroadcast())?_c('broadcast-type-label',{attrs:{"type":_vm.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }